/**
 * A situação de um Pix cobrado (F205), lida pelo relatório do site e pelo
 * app do celular (F310).
 */
export const PIX_STATUS_TEXT = {
    pending: { label: 'Aguardando', tone: 'warning' },
    paid: { label: 'Pago', tone: 'success' },
    expired: { label: 'Expirou', tone: 'neutral' },
    failed: { label: 'Falhou', tone: 'danger' },
    cancelled: { label: 'Cancelado', tone: 'neutral' },
};
/** `2026-10-22` → `22/10/2026`: o dia do "Por dia". */
export const pixDayLabel = (day) => {
    const [year, month, date] = day.split('-');
    return `${date ?? ''}/${month ?? ''}/${year ?? ''}`;
};
//# sourceMappingURL=pix.js.map